import AuthRules from "./AuthRules";

export default {
  AuthRules,
};
